import { useTranslate } from '@growtherapy/i18n';
import { Body, Label } from '@growtherapy/sprout-ui';

export function ResourcesTable({ resources }: { resources: string[] }): JSX.Element {
  const t = useTranslate();

  return (
    <div>
      <Label.Small emphasis className='rebrand:font-semibold'>
        {t('telehealth-core:providerIntersessionSummary.resources')}
      </Label.Small>
      {resources.length ? (
        resources.map((resource, index) => (
          <div key={index} className='flex flex-row border-b py-2 rebrand:border-border-subtle justify-between w-full'>
            <Body.Small className='text-neutral-700 rebrand:text-text-muted'>{resource}</Body.Small>
          </div>
        ))
      ) : (
        <Body.Small className='text-neutral-700 rebrand:text-text-muted'>
          {t('telehealth-core:providerIntersessionSummary.tryAssigningResources')}
        </Body.Small>
      )}
    </div>
  );
}
